import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_Excel_Interface } from 'src/app/Interface/Customer_Excel_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-CustomerList',
  templateUrl: './CustomerList.component.html',
  styleUrls: ['./CustomerList.component.scss']
})
export class CustomerListComponent implements OnInit {

  modalRef_Delete: any;
  modalRef_Special: any;
  modalRef_Acrchive: any;
  BaseUrl = environment.Print_URL + "Customer/"

  constructor(
    private Customer_Service: CustomerService,
    private Alertify_Service: AlertifyService,
    private province_Service: ProvinceService,
    private Nav_Service: NavService,
    private FeildActivity_Service: FeildActivityService,
    private modalService: BsModalService
  ) { }
  page: number = 0;
  Procssing: boolean = false

  StartSearchDate: string = ''
  Name: string = ''
  Code: string = ''
  EndSearchDate: string = ''
  Karshenas: string = ''
  SubmitPeriodDate: string = '0'
  HasCertificateAddress: string = '0'

  ngOnInit() {
    this.Nav_Service.CheckValidPage(16).subscribe(
      data => {
        this.Read_Service_Province("")
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  DataList_Customer: Array<Customer_List_Interface> = []
  Data_View_Customer: Customer_List_Interface = Empty_Customer_List_Interface()
  Data_View_Customer_Switcher:string=''
  DataList_Customer_Excel: Array<Customer_Excel_Interface> = []
  Data_Seleted_Delete: any

  ReadData_Customer(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.StartSearchDate = StartSearchDate
    this.EndSearchDate = EndSearchDate

    this.Customer_Service.GetRecord1(this.ProvinceId,
      this.CityId,
      this.Name,
      this.Code,
      this.Karshenas,
      0,
      Number(this.SubmitPeriodDate),
      Number(this.HasCertificateAddress),
      this.FeildActivityId,
      StartSearchDate,
      EndSearchDate,
      false).subscribe(
        data => {
          this.DataList_Customer = data['model']
          this.DataList_Customer_Excel = data['excel']
          this.Procssing = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }


  current_Month_create: number = 0
  current_Month_update: number = 0
  total: number = 0

  Read_GetDetailCount() {
    this.Customer_Service.GetDetailCount().subscribe(
      data => {
        this.current_Month_create = data['current_Month_create']
        this.current_Month_update = data['current_Month_update']
        this.total = data['total']
      }
    )
  }

  Delete(item: Customer_List_Interface) {
    item.DeletingProccess = true
    this.modalRef_Delete.hide()
    this.Customer_Service.DeleteCustomer(item.id).subscribe(
      data => {
        if (item.del == false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")

        this.ReadData_Customer(this.StartSearchDate, this.EndSearchDate)
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Acrchive(item: Customer_List_Interface) {
    item.DeletingProccess = true
    this.modalRef_Acrchive.hide()
    this.Customer_Service.AcrchiveCustomer(item.id).subscribe(
      data => {
        if (data.id == -1)
        {
          this.Alertify_Service.ErrorMessage("امکان حذف بدلیل ثبت داده وجود ندارد")
          item.DeletingProccess = false
        }
        else
        {
          this.Alertify_Service.SuccessMessage("حذف شد")
          this.ReadData_Customer(this.StartSearchDate, this.EndSearchDate)
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  Special(item: Customer_List_Interface) {
    item.DeletingProccess = true
    this.modalRef_Special.hide()
    this.Customer_Service.SpecialCustomer(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات شد")

        this.ReadData_Customer(this.StartSearchDate, this.EndSearchDate)
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }





  FeildActivityId: string = "0"
  ProvinceId: string = "0"
  CityId: string = "0"


  //#region Province

  DataList_Province: Array<General_Interface> = []
  DataList_City: Array<General_Interface> = []

  Read_Service_Province(id: string) {
    this.province_Service.GetRecord(id).subscribe(
      data => {
        if (id == "") {
          this.DataList_Province = data
          this.ReadData_FeildActivity()
        }
        else {
          this.DataList_City = data
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ProvinceChange() {
    this.CityId = "0"
    if (this.ProvinceId == "0") {
      this.DataList_City = []
    }
    else {
      this.Read_Service_Province(this.ProvinceId)
    }
  }


  //#endregion


  DataList_FeildActivity: Array<FeildActivity_Interface> = []
  ReadData_FeildActivity() {
    this.FeildActivity_Service.GetRecord().subscribe(
      data => {
        this.DataList_FeildActivity = data
        this.Read_GetDetailCount()

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  openModalSpecial(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Special = this.modalService.show(template);
  }

  openModalAcrchive(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Acrchive= this.modalService.show(template);
  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaCsutomer.xlsx");

  }



  Set_Customer_view(item:Customer_List_Interface,switcher:string)
  {
    this.Data_View_Customer_Switcher=switcher
    this.Data_View_Customer=item
  }

  OnBack_Componet_Action_Rest(item:any)
  {
    this.Data_View_Customer_Switcher=''
    this.Data_View_Customer=Empty_Customer_List_Interface()
  }

}
